module.exports = __webpack_public_path__ + "img/senalando-izq.70ac72be.png";